import {
  PublicKey,
  TransactionInstruction,
  TransactionMessage,
  VersionedTransaction,
} from '@solana/web3.js';
import { getLatestBlockhash } from '@/helpers/solana/getLatestBlockHash';

export async function prepareTransaction(
  instructions: TransactionInstruction[],
  payer: PublicKey,
) {
  const blockhash = await getLatestBlockhash();
  const messageV0 = new TransactionMessage({
    payerKey: payer,
    recentBlockhash: blockhash,
    instructions,
  }).compileToV0Message();
  return new VersionedTransaction(messageV0);
}
